// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"784f7fde","450":"fda44bd4"}[chunkId] + ".chunk.js";
};